import { BaseModel } from "./base-model.model";

export class CatalogItem extends BaseModel {
    catalogId: number;
    itemId: number
}
